import React from 'react';
import CoreSvg from '../CoreSvg';
import Icon from 'shared/icons';
import { FilterDefaultChips, LeftIconWrapper } from './style';
import { IFilterChips } from './type';
import { useTheme } from 'styled-components';

const FilterDefault = ({
	value,
	selected,
	setSelected,
	_disabled = false,
}: IFilterChips) => {
	const theme = useTheme();
	return (
		<>
			<FilterDefaultChips
				selected={selected === value || selected?.includes(value)}
				disabled={_disabled}
				onClick={() => {
					if (_disabled) return;
					setSelected && setSelected(value);
				}}
			>
				{(selected === value || selected?.includes(value)) && (
					<LeftIconWrapper>
						<CoreSvg _fill={theme.colors.primary.primary80_darken}>
							<Icon.Check />
						</CoreSvg>
					</LeftIconWrapper>
				)}
				{value}
			</FilterDefaultChips>
		</>
	);
};

export default FilterDefault;
